"use strict";

document.addEventListener('DOMContentLoaded', () => {
  const activeClass = 'gr-submenu-active';
  const submenuOpenerAttr = '[data-grjs="submenu-open"]';
  const submenuCloserAttr = '[data-grjs="submenu-close"]';
  const withSubmenuAttr = '[data-grjs="with-submenu"]';
  const addActiveClass = element => {
    document.querySelectorAll(withSubmenuAttr).forEach(el => {
      if (el !== element) {
        el.classList.remove(activeClass);
      }
    });
    element.classList.add(activeClass);
  };
  const removeActiveClass = element => element.classList.remove(activeClass);
  document.body.addEventListener('click', _ref => {
    let {
      target
    } = _ref;
    const opener = target.closest(submenuOpenerAttr);
    if (opener) {
      const parentElement = opener.closest(withSubmenuAttr);
      if (parentElement) {
        addActiveClass(parentElement);
      }
      return;
    }
    const closer = target.closest(submenuCloserAttr);
    if (closer) {
      const parentElement = closer.closest(withSubmenuAttr);
      if (parentElement) {
        removeActiveClass(parentElement);
      }
    }
  });
});